module.exports = __webpack_public_path__ + "static/media/excel.8a55da7a.svg";